import { Component } from '@angular/core';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';

/**
 * Host único del popup custom. Se coloca una sola vez (en AppComponent) y
 * refleja el estado de PopUpModalCustomService.
 */
@Component({
    selector: 'app-modal-custom-host',
    templateUrl: './modal-custom-host.component.html',
})
export class ModalCustomHostComponent {

    constructor(public modalCustom: PopUpModalCustomService) { }
}
